import React from 'react';
import OrderListPage from './OrderListPage';

interface IProps {
  handleModalOpen: (data: any) => void;
  rowDetails: any;
  setRowDetails: any;
}

const ShippingOrders = (props: IProps) => (
  <OrderListPage
    section="Order in Shipping"
    emptyMessage="No orders in shipping."
    {...props}
  />
);

export default ShippingOrders;
